import React from 'react';
import {useLocation} from 'react-router';
import {useNavigate} from 'react-router-dom';
import {CheckCircleOutlined} from '@ant-design/icons';
import { Button } from 'antd';

import {INDEX} from '../../../../config/routes';

import cls from './Success.module.scss'


export const SuccessSevenDays = () => {

    const navigate = useNavigate()
    const {state} = useLocation();
    const {CertNumber} = state;

    return (
        <div className={cls.page}>
            <div className={'content'}>
                <div className={cls.text}>
                    <h2><CheckCircleOutlined className={'color-success'}/> Ваша заявка на возврат принята</h2>
                    <p>
                        Уважаемый Клиент,<br/>
                        Группа компаний «FTS Group» благодарит Вас за обращение.
                    </p>
                    <p>
                        Ваша заявка на&nbsp;возврат по&nbsp;сертификату <b>{CertNumber}</b> принята.
                    </p>
                    <p>
                        Группа компаний «FTS Group» гарантирует возврат средств за сертификат в течение 7 рабочих дней, в случае если это предусмотрено условиями сертификата.                    </p>
                    <p>
                        Денежные средства вернуться на карту, с которой производилась оплата сертификата.
                    </p>
                    <Button type={'primary'} size={'large'} onClick={() => navigate(INDEX)}>Хорошо</Button>
                </div>
            </div>

            {/*<Banner/>*/}

        </div>
    )
}


